"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getChartData;

var _lodash = require("lodash");

function addPointToSeries(point, seriesCollection, seriesName) {
  if (seriesCollection[seriesName] === undefined) {
    seriesCollection[seriesName] = {
      name: seriesName,
      type: "column",
      data: []
    };
  }

  seriesCollection[seriesName].data.push(point);
}

function getChartData(data, options) {
  var series = {};
  var mappings = options.columnMapping;
  (0, _lodash.each)(data, row => {
    var point = {
      $raw: row
    };
    var seriesName = null;
    var xValue = 0;
    var yValues = {};
    var eValue = null;
    var sizeValue = null;
    var zValue = null;
    (0, _lodash.forOwn)(row, (value, definition) => {
      definition = "" + definition;
      var definitionParts = definition.split("::") || definition.split("__");
      var name = definitionParts[0];
      var type = mappings ? mappings[definition] : definitionParts[1];

      if (type === "unused") {
        return;
      }

      if (type === "x") {
        xValue = value;
        point[type] = value;
      }

      if (type === "y") {
        yValues[name] = value;
        point[type] = value;
      }

      if (type === "yError") {
        eValue = value;
        point[type] = value;
      }

      if (type === "series") {
        seriesName = String(value);
      }

      if (type === "size") {
        point[type] = value;
        sizeValue = value;
      }

      if (type === "zVal") {
        point[type] = value;
        zValue = value;
      }

      if (type === "multiFilter" || type === "multi-filter") {
        seriesName = String(value);
      }
    });

    if ((0, _lodash.isNil)(seriesName)) {
      (0, _lodash.each)(yValues, (yValue, ySeriesName) => {
        point = {
          x: xValue,
          y: yValue,
          $raw: point.$raw
        };

        if (eValue !== null) {
          point.yError = eValue;
        }

        if (sizeValue !== null) {
          point.size = sizeValue;
        }

        if (zValue !== null) {
          point.zVal = zValue;
        }

        addPointToSeries(point, series, ySeriesName);
      });
    } else {
      addPointToSeries(point, series, seriesName);
    }
  });
  return (0, _lodash.sortBy)((0, _lodash.values)(series), (_ref) => {
    var name = _ref.name;

    if ((0, _lodash.isObject)(options.seriesOptions[name])) {
      return options.seriesOptions[name].zIndex || 0;
    }

    return 0;
  });
}
//# sourceMappingURL=getChartData.js.map